import { Lightning } from "@lightningjs/sdk";
import { SubtitleTrack } from "bitmovin-player";
import configs from "../../../../../lib/configs";
import { SettingsPopupCompact } from "./SettingsPopupCompact";
import { SettingsPopupFullScreen } from "./SettingsPopupFullScreen";

interface SettingsPopupTemplateSpec extends Lightning.Component.TemplateSpec {
    Popup: typeof SettingsPopupCompact | typeof SettingsPopupFullScreen;
}

export class SettingsPopup
    extends Lightning.Component<SettingsPopupTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SettingsPopupTemplateSpec>
{
    readonly Popup = this.getByRef("Popup")!;

    static override _template(): Lightning.Component.Template<SettingsPopupTemplateSpec> {
        const isFullScreen = configs.layout?.playback?.settings === "fullscreen";
        return {
            collision: true,
            Popup: {
                type: isFullScreen ? SettingsPopupFullScreen : SettingsPopupCompact
            }
        };
    }

    override _getFocused() {
        return this.Popup;
    }

    override _handleLeft() {}

    override _handleRight() {}

    override _handleUp() {}

    override _handleDown() {}

    setAvailableSubtitles(subtitles: SubtitleTrack[]) {
        if (this.Popup.setAvailableSubtitles) {
            this.Popup.setAvailableSubtitles(subtitles);
        }
    }

    setAvailableAudioLanguages(subtitles: any[]) {
        if (this.Popup.setAvailableAudioLanguages) {
            this.Popup.setAvailableAudioLanguages(subtitles);
        }
    }

    setSubtitlePreference(lang: string) {
        if (this.Popup.setSubtitlePreference) {
            this.Popup.setSubtitlePreference(lang);
        }
    }

    // setAvailableAudioLanguages(languages: Array<{ language: string; languageName: string }>) {
    //     if (this.Popup.setAvailableAudioLanguages) {
    //         this.Popup.setAvailableAudioLanguages(languages);
    //     }
    // }
    //
    // setAudioPreference(lang: string) {
    //     if (this.Popup.setAudioPreference) {
    //         this.Popup.setAudioPreference(lang);
    //     }
    // }

    get currentMenu() {
        return (this.Popup as any).currentMenu || "main";
    }

    set currentMenu(value: string) {
        (this.Popup as any).currentMenu = value;
    }

    get _index() {
        return (this.Popup as any)._index || 0;
    }

    set _index(value: number) {
        (this.Popup as any)._index = value;
    }

    open() {
        if (this.Popup.open) {
            this.Popup.open();
        }
    }

    close() {
        if (this.Popup.close) {
            this.Popup.close();
        }
    }
}
